// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__0MPg2","sliderItem":"Slider_sliderItem__ZlfPw","slick":"Slider_slick__P3rsY"};